import { Injectable } from "@angular/core";
import { StaffPayrollService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { StaffPayrollPort } from "../../../app/ports/payroll/staff-payroll.port";
import {
  PayrollPeriod,
  PayrollPeriodRequest,
  PayrollPeriodStatus,
  PayrollRun,
  Payslip,
  PayslipRequest,
  PayslipStatus,
} from "../../../domain/models/payroll/payroll.model";
import {
  mapPayrollPeriod,
  mapPayrollPeriodRequest,
  mapPayrollRun,
  mapPayslip,
  mapPayslipRequest,
} from "../../mappers/payroll/payroll.mapper";

@Injectable({ providedIn: "root" })
export class StaffPayrollPortAdapter implements StaffPayrollPort {
  constructor(private readonly api: StaffPayrollService) {}

  listPeriods(filters?: {
    companyId?: number;
    year?: number;
    month?: number;
    status?: PayrollPeriodStatus;
  }): Observable<PayrollPeriod[]> {
    return this.api.listPeriods(filters).pipe(map((items) => items.map(mapPayrollPeriod)));
  }

  getPeriod(periodId: number): Observable<PayrollPeriod> {
    return this.api.getPeriod(periodId).pipe(map(mapPayrollPeriod));
  }

  createPeriod(request: PayrollPeriodRequest): Observable<PayrollPeriod> {
    return this.api.createPeriod(mapPayrollPeriodRequest(request)).pipe(map(mapPayrollPeriod));
  }

  calculatePeriod(periodId: number): Observable<PayrollRun> {
    return this.api.calculatePeriod(periodId).pipe(map(mapPayrollRun));
  }

  publishPeriod(periodId: number): Observable<PayrollRun> {
    return this.api.publishPeriod(periodId).pipe(map(mapPayrollRun));
  }

  closePeriod(periodId: number): Observable<PayrollPeriod> {
    return this.api.closePeriod(periodId).pipe(map(mapPayrollPeriod));
  }

  savePayslip(periodId: number, request: PayslipRequest): Observable<Payslip> {
    return this.api.savePayslip(periodId, mapPayslipRequest(request)).pipe(map(mapPayslip));
  }

  listPayslips(filters?: {
    companyId?: number;
    employeeId?: number;
    year?: number;
    month?: number;
    status?: PayslipStatus;
    signed?: boolean;
  }): Observable<Payslip[]> {
    return this.api.listPayslips(filters).pipe(map((items) => items.map(mapPayslip)));
  }

  getPayslip(payslipId: number): Observable<Payslip> {
    return this.api.getPayslip(payslipId).pipe(map(mapPayslip));
  }

  attachDocument(payslipId: number, documentUrl: string): Observable<Payslip> {
    return this.api.attachDocument(payslipId, documentUrl).pipe(map(mapPayslip));
  }

  signPayslip(payslipId: number): Observable<Payslip> {
    return this.api.signPayslip(payslipId).pipe(map(mapPayslip));
  }
}
